/**
 * TEMU OpenAPI 路径与字段映射（单一来源，随开放平台文档更新）
 * @see https://open.temucorp.com/
 */

export const TEMU_OPEN_API_PATHS = {
  AUTH_GET_BY_TOKEN: '/open-api/auth/get-by-token',
  PRODUCT_QUERY: '/open-api/openapi-business-backend/product/query',
  PRODUCT_FULL_DETAIL: '/open-api/openapi-business-backend/product/full-detail',
  PUBLISH_OR_EDIT: '/open-api/goods/product/publishOrEdit',
  PARTIAL_EDIT: '/open-api/goods/product/partialEdit',
  CHECK_PUBLISH_PERMISSION: '/open-api/goods/product/check-publish-permission',
  CHECK_EDIT_PERMISSION: '/open-api/goods/product/check-edit-permission',
  QUERY_DOCUMENT_STATE: '/open-api/goods/query-document-state',
  REVOKE_PRODUCT: '/open-api/goods/revoke-product',
  SEARCH_PRODUCT: '/open-api/goods/searchProduct',
  QUERY_SITE_LIST: '/open-api/goods/query-site-list',
  QUERY_BRAND_LIST: '/open-api/goods/query-brand-list',
  QUERY_IP_LIST: '/open-api/goods/query-ip-list',
  QUERY_CATEGORY_TREE: '/open-api/goods/query-category-tree',
  /**
   * 注意：Shein 路径，Temu 不存在。Temu 发品约束请用后端
   * GET /api/temu/shops/{id}/publish/standard（currencyType=CNY|USD）。
   * @deprecated 勿对 Temu 店铺调用
   */
  QUERY_PUBLISH_FILL_IN_STANDARD: '/open-api/goods/query-publish-fill-in-standard',
  GET_ASSOCIATED_ATTRIBUTE_RULES: '/open-api/goods/get-associated-attribute-rules',
  CHECK_SUPPLIER_SKU_REPEATED: '/open-api/goods/product/check-supplierSku-repeated',
  /** 半托管商家仓库地址列表（发品 supplier_warehouse_*） */
  WAREHOUSE_ADDRESS: '/open-api/gsp/warehouse-address',
  MSC_WAREHOUSE_LIST: '/open-api/msc/warehouse/list',
  SUGGESTED_PRICE_LIST: '/open-api/goods/suggested-price-list',
  /** 按 SKU 查销量（全托管/半托管） */
  QUERY_SKU_SALES: '/open-api/goods/query-sku-sales',
  TRANSFORM_PIC: '/open-api/goods/transform-pic',
  GET_CERTIFICATE_RULE: '/open-api/goods/get-certificate-rule',
  CERTIFICATE_TYPE_LIST_V2: '/open-api/goods/certificate/get-all-certificate-type-list-v2',
  UPLOAD_CERTIFICATE_FILE: '/open-api/goods/upload-certificate-file',
  SAVE_CERTIFICATE_POOL: '/open-api/goods/save-or-update-certificate-pool',
  SAVE_SUPPLIER_CERTIFICATE: '/open-api/goods/save-or-update-supplier-certificate',
  SAVE_CERTIFICATE_POOL_SKC_BIND: '/open-api/goods/save-certificate-pool-skc-bind',
  /** 资质证书（证书库 / 产品补证写路径） */
  CERTIFICATE_SEARCH: '/open-api/goods-certificates/search',
  CERTIFICATE_SAVE: '/open-api/goods-certificates/save',
  CERTIFICATE_SCHEMAS_DETAIL: '/open-api/goods-certificate-schemas/detail',
  CERTIFICATE_FILES_UPLOAD: '/open-api/goods-certificate-files/upload',
  CERTIFICATE_BIND: '/open-api/goods-certificates/bind',
  /** 统一合规要求列表（产品补证同步主路径） */
  COMPLIANCE_REQUIREMENTS_LIST: '/open-api/goods-compliance-requirements/list',
  COMPLIANCE_AGENCY_LIST: '/open-api/goods-compliance/agency-list',
  COMPLIANCE_SKC_DETAIL: '/open-api/goods-compliance/skc-agency-detail',
  COMPLIANCE_SAVE_SKC_AGENCY: '/open-api/goods-compliance/save-skc-agency',
  COMPLIANCE_WARNING_RULES: '/open-api/goods-compliance/query-warning-certificate-rules',
  COMPLIANCE_UPDATE_SKC_WARNING: '/open-api/goods-compliance/update-skc-warning-certificate',
  COMPLIANCE_SKC_WARNING_STATUS: '/open-api/goods-compliance/query-skc-warning-status',
  COMPLIANCE_SKC_LABEL_LIST: '/open-api/goods-compliance/skc-label-list',
  COMPLIANCE_UPLOAD_SKC_LABEL_PICTURE: '/open-api/goods-compliance/upload-skc-label-picture',
  COMPLIANCE_SKC_SAVE_LABEL: '/open-api/goods-compliance/skc-save-label',
  COMPLIANCE_GET_LABEL_TEMPLATE: '/open-api/goods-compliance/get-label-template',
  COMPLIANCE_LABEL_PRINT: '/open-api/goods-compliance/label-print',
  ENVIRONMENTAL_MATERIAL_TREE_V2:
    '/open-api/goods-quality/environmental-label-rule/material-quality-tree-v2',
  RETURN_ORDER_LIST: '/open-api/return-order/list',
  RETURN_ORDER_DETAILS: '/open-api/return-order/details',
  RETURN_ORDER_SIGN: '/open-api/return-order/sign-return-order',
  DISCUSS_QUERY_LIST: '/open-api/goods/discuss/query-discuss-list',
  DISCUSS_PROCESS: '/open-api/goods/discuss/process-discuss',
  DISCUSS_UPLOAD_FILE: '/open-api/goods/discuss/upload-discuss-file',
  RECOMMEND_RETAIL_SEARCH: '/open-api/goods-recommend-retail-price/search',
  RECOMMEND_RETAIL_RULE: '/open-api/goods/query-recommend-retail-price-rule',
  RECOMMEND_RETAIL_BATCH_SAVE: '/open-api/goods-recommend-retail-price/batch-save',
  RECOMMEND_RETAIL_AUDIT_SEARCH: '/open-api/goods-recommend-retail-price-audit/search',
  /** 更新成本价/供货价（半托管/全托管） */
  UPDATE_COST: '/open-api/goods/update-cost',
  /** 获取成本价涨价原因（半托管/全托管） */
  QUERY_CHANGE_PRICE_REASON: '/open-api/goods/query-change-price-reason',
  /** 更新售价（自运营） */
  PRODUCT_PRICE_SAVE: '/open-api/openapi-business-backend/product/price/save',
  ORDER_LIST: '/open-api/order/order-list',
  ORDER_DETAIL: '/open-api/order/order-detail',
  LOGISTICS_TRACK: '/open-api/gsp/logistics-track',
  FINANCE_CHECK_ORDER_LIST: '/open-api/finance/get-check-order-list',
  FINANCE_CHECK_ORDER_DETAIL: '/open-api/finance/get-check-order-detail',
  FINANCE_REPORT_LIST: '/open-api/finance/report-list',
  FINANCE_REPORT_SALES_DETAIL: '/open-api/finance/report-sales-detail',
  FINANCE_REPORT_ADJUSTMENT_DETAIL: '/open-api/finance/report-adjustment-detail',
  FINANCE_REPORT_ORDER_LIST: '/open-api/finance/report-order-list',
};

/** 对账单状态（列表响应 checkStatus） */
export const FINANCE_CHECK_STATUS_LABELS = {
  1: '待生成付款',
  2: '即将付款',
  3: '已付款',
  4: '付款异常',
};

/** 自运营/半托管报账单状态 reportStatus */
export const FINANCE_REPORT_STATUS_LABELS = {
  1: '即将付款',
  2: '已付款',
  3: '付款异常',
};

/** 全托管报账单结算状态 settlementStatus */
export const FINANCE_SETTLEMENT_STATUS_LABELS = {
  1: '待确认',
  2: '待结算',
  3: '已结算',
};

/** 收支类型 */
export const FINANCE_IN_OUT_LABELS = {
  1: '收入',
  2: '支出',
};

/** 结算账单收款方式（report-order-list.paymentMethod） */
export const FINANCE_PAYMENT_METHOD_LABELS = {
  1: '直接打款',
  2: '钱包充值',
};

/**
 * 对账单二级类型 secondOrderType（自运营/半托管 FAQ）
 * @see temu-finance.md
 */
export const FINANCE_CHECK_SECOND_ORDER_TYPE_LABELS = {
  1: '订单收入',
  2: '订单退货',
  3: '订单调整',
  4: '仓库退货',
  5: '丢货补款',
  6: '订单异常补款',
  8: '订单异常扣款',
  10: '银行打款验证',
  11: '订单状态修正',
  12: '订单履约服务费',
  13: '退货履约服务费',
  14: '订单履约服务费退还',
  15: '履约服务费补款',
  16: '履约服务费扣款',
  17: '违规处罚补款',
  18: '违规处罚扣款',
  19: '平台激励补款',
  20: '平台激励扣款',
  21: '税费补款',
  22: '税费扣款',
  23: '备货作业费',
  24: '退货冻结差额补款',
  25: '退货冻结差额扣款',
  26: '退货丢货补款',
  27: '取消订单补款',
  34: '退货处理费',
  35: 'GNRE税费补款',
  36: 'GNRE税费扣款',
  37: '标准仓储费',
  38: '超库龄附加仓储费',
  39: '交易申诉补款',
  40: '商家扣款单',
  41: '库存盘亏',
  42: '库存盘盈',
  43: '仓储费补款',
  44: '仓储费扣款',
  45: 'EPR补款',
  46: 'EPR扣款',
  47: 'SFS备货揽收费用',
  48: '海外备货运费补款',
  49: '海外退供运费扣款',
  50: '仓储货物赔付补款',
  51: '仓储增值服务扣款',
  52: '商家合作押金补款',
  53: '定制化商家履约服务费补款',
  54: '税费补贴',
  55: '税费补贴退回',
  56: '其他应补款',
  57: '其他应扣款',
  58: '线下欠款回收',
  59: '运费补贴',
  60: '运费补贴退回',
  61: '退货运费补贴',
  62: '代收服务费',
  63: '违规处罚资金冻结',
  64: '违规撤销资金解冻',
  65: '履约服务费附加费',
  66: 'CA消费税补贴',
  67: 'CA消费税补贴退回',
  68: 'DIFAL增值税扣款',
  69: '客单正向成本调整',
  70: '客单逆向成本调整',
  71: '客单结算',
  72: '退货结算',
  73: '支付手续费',
  74: 'SFS退供运费',
  75: '推客佣金补款',
  76: '推客佣金扣款',
};

export const RETURN_ORDER_STATUS_LABELS = {
  1: '已关闭',
  2: '申请中',
  3: '已取消',
  5: '卖家已收货',
  6: '已送达',
  7: '待交接',
  8: '待TEMU转账',
  9: '已完成',
};

/** 销售订单状态（order-list / order-detail.orderStatus；与商品 newGoodsStatus 枚举对齐） */
export const SALES_ORDER_STATUS_LABELS = {
  1: '待处理',
  2: '待发货',
  3: '待TEMU发货',
  4: '已发货',
  5: '已签收',
  6: '用户已退款',
  7: '待揽收',
  8: '已报损',
  9: '已拒收',
};

/** 订单列表状态维度 Tab（含全部） */
export const SALES_ORDER_STATUS_TABS = [
  { value: '', label: '全部' },
  ...Object.entries(SALES_ORDER_STATUS_LABELS).map(([value, label]) => ({ value, label })),
];

/** 库存模式 stockMode */
export const SALES_ORDER_STOCK_MODE_LABELS = {
  1: 'TEMU自营库存',
  2: '备货到TEMU仓(SFS)',
  3: '商家仓发货',
};

/**
 * 核价单状态（半托 bg.semi.price.review.* / 全托 bg.price.review.* 的 orderStatus；两套 type 不可混用）
 * 0 待核价；1 待供应商确认；2 核价通过；3 核价驳回；4 废弃；5 价格同步中
 */
export const DISCUSS_STATUS_LABELS = {
  0: '待核价',
  1: '待供应商确认',
  2: '核价通过',
  3: '核价驳回',
  4: '废弃',
  5: '价格同步中',
};

/** 核价单类型（平台若返回则展示；无则列表显示原始值） */
export const DISCUSS_TYPE_LABELS = {
  0: '日常核价',
  1: '活动核价',
};

/**
 * 调价单状态（半托 bg.semi.adjust.price.* / 全托 bg.full.adjust.price.* 的 status；两套 type 不可混用）
 * 0 待调价；1 待卖家确认；2 调价成功；3 调价失败
 * （历史命名 RRP_SKC，页面「调价单」复用此常量）
 */
export const RRP_SKC_STATUS_LABELS = {
  0: '待调价',
  1: '待卖家确认',
  2: '调价成功',
  3: '调价失败',
};

/** 建议零售价填写规则：材料要求 */
export const RRP_MATERIAL_REQUIREMENT_LABELS = {
  0: '不需要填材料',
  1: '类型一材料必填（文件必填，链接选填）；类型二选填',
  2: '类型一或类型二至少填一种',
};

/** 建议零售价审核状态 */
export const RRP_AUDIT_STATE_LABELS = {
  1: '待审核',
  2: '审核成功',
  3: '审核失败',
  5: '部分通过',
  6: '已撤回',
};
